export enum ITabs {
  CONTACT = "Contact",
  COMPANY = "Company",
  GROUPS = "Groups",
  NOTES = "Notes",
}
